export const frontmatter = {
    "title": "Key Concepts",
    "sidebar_group": "concepts",
    "sidebar_label": "Concepts",
    "sidebar_order": 3
}

export const toc = []